function BaseballComingSoonView() {
  return (
    <div className='card'>
      <div className='empty-state'>
        <h3>Baseball Rankings — Coming Soon</h3>
        <p>MLB fantasy rankings are on the way. Check back soon!</p>
      </div>
    </div>
  );
}

export default BaseballComingSoonView;
